import { Marked } from "marked"
import hljs from "highlight.js"
import mermaid from "mermaid"

export { hljs }

mermaid.initialize({
  startOnLoad: false,
  theme: "default",
  securityLevel: "loose",
})

const marked = new Marked({ breaks: true, gfm: true })

marked.use({
  renderer: {
    code({ text, lang }) {
      if (lang === "mermaid") {
        return `<pre class="mermaid">${text}</pre>`
      }
      const language = lang && hljs.getLanguage(lang) ? lang : undefined
      const highlighted = language
        ? hljs.highlight(text, { language }).value
        : hljs.highlightAuto(text).value
      const langClass = language ? ` language-${language}` : ""
      return `<pre><code class="hljs${langClass}">${highlighted}</code></pre>`
    }
  }
})

export function renderMarkdown(text) {
  return marked.parse(text || "")
}

export async function renderMermaid(container) {
  const elements = container.querySelectorAll("pre.mermaid:not([data-processed])")
  if (elements.length > 0) {
    try {
      await mermaid.run({ nodes: Array.from(elements) })
    } catch (e) {
      console.warn("Mermaid render error:", e)
    }
  }
}
